import { useEffect, useState } from "react";
import NavBar from "../../components/NavBar/NavBar";
import poweredByStripe from "../../assets/poweredByStripe.svg";
import "./SignUpPage.scss";
import { useSearchParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../../components/CheckoutForm/CheckoutForm";
import Checkmark from "../../components/Checkmark/Checkmark";
import Footer from "../../components/Footer/Footer";
import axiosClient from "../../axiosClient";
import { PASSWORD_REQUIREMENTS_HINT } from "../../utils/passwordRequirements";
import toast from "react-hot-toast";
import PRODUCTS from "./products";
import {
  CouponSection,
  ProductPicker,
  getComingSoonProducts,
  getPurchasableProducts,
  useCoupon,
} from "../../components/ProductPicker/ProductPicker";
import { marketingUrl } from "../../lib/marketingUrls";
import { brand, contactEmail, contactMailto } from "../../brand";

function SignUpPage() {
  const [stripePromise, setStripePromise] = useState<any>(null);
  const [subscriptionType, setSubscriptionType] = useState<'monthly' | '6_monthly'>("6_monthly");
  const [selectedProducts, setSelectedProducts] = useState<Set<string>>(new Set())
  const coupon = useCoupon({
    products: PRODUCTS,
    selectedProducts,
    getEmail: () => (document.getElementById("email") as HTMLInputElement | null)?.value?.trim() ?? "",
  });
  const { appliedCoupon, totalPrice } = coupon;

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    const prod = searchParams.get("product");

    if (prod && PRODUCTS.map(p => p.id).includes(prod) && !PRODUCTS.find(p => p.id == prod)?.comingSoon && (PRODUCTS.find(p => p.id == prod) as { showOnSignUp?: boolean })?.showOnSignUp !== false) {
      const cloneSelectedProducts = new Set(selectedProducts);
      cloneSelectedProducts.add(prod);
      setSelectedProducts(cloneSelectedProducts)
    }

    try {
      const fetchStripeConfig = async () => {
        const r = await axiosClient.get('payments/config')
        const { publishableKey } = r.data
        setStripePromise(loadStripe(publishableKey));
      }

      fetchStripeConfig()
    } catch (err) {
      toast.error("Error occured whilst loading page. Please seek support!");
      console.error(err);
    }
  }, []);

  useEffect(() => {
    console.log(subscriptionType);
  }, [subscriptionType])

  const purchasableProducts = getPurchasableProducts(PRODUCTS);
  const comingSoonProducts = getComingSoonProducts(PRODUCTS);
  return (
    <>
      <NavBar />
      <div id="SignUpPage">
        <div className="site-container">
          <div className="order-summary-wrapper">
            <div className="order-summary-inner">
              {/* <div className="big-logo-wrapper">
                <img src={logo} className="big-logo" alt="" />
              </div> */}

              <div className="inner-cols-wrapper">
                <div className="order-summary-col">
                  <form id="form-wrapper">
                    <h3 className="order-summary-section-title">
                      Purchase Form
                    </h3>

                    <h5 className="signup-form-heading">Products</h5>

                    <p>Please select all the products you wish to purchase.</p>

                    <ProductPicker
                      products={purchasableProducts}
                      selected={selectedProducts}
                      onChange={setSelectedProducts}
                      multiple
                    />


                    {comingSoonProducts.length > 0 && (
                      <>
                        <h6 className="signup-form-heading signup-form-heading--minor">Products coming soon:</h6>
                        <p>The products below will be available to purchase soon.</p>
                        {comingSoonProducts.map(product => {
                          let className = "oq-product-card-wrapper oq-product-card-wrapper-coming-soon";
                          let priceLabel;
                          if (product.price) {
                            priceLabel = <label htmlFor={product.id}>{product.title}: <span>£{product.price}</span> / {product.length}</label>;
                          }
                          else {
                            priceLabel = <label htmlFor={product.id}>{product.title}: <span>(price to be confirmed)</span> </label>
                          }
                          return (
                            <div>
                              <div className={className} title="This product is not available for purchase yet." onClick={(e) => {
                                e.preventDefault();
                                toast("This product is not available for purchase yet, but we intend to have it ready soon.")
                              }}>
                                <div>
                                  <input
                                    name={product.id}
                                    id={product.id}
                                    type="checkbox"
                                    checked={selectedProducts.has(product.id)}
                                    className="oq-product-card-checkbox"
                                  />
                                  {priceLabel}
                                </div>
                                <span className="coming-soon">coming soon</span>
                              </div>
                            </div>
                          )
                        })}
                      </>
                    )}

                    {/* <p style={{
                      fontSize: 'smaller',
                      marginTop: '25px'
                    }}><strong>NOTE:</strong>You may select more than one product, and you may purchase additional ones after you've signed up too.</p> */}

                    {selectedProducts.size > 0 && (
                      <div id="totalPrice" className="signup-total-block">
                        {!appliedCoupon && (
                          <h2 className="signup-total-heading">
                            Total: <span className="signup-total-amount">£{totalPrice()}</span>{" "}
                            <span className="signup-total-note">due today</span>
                          </h2>
                        )}
                        {appliedCoupon && (
                          <div>
                            <div className="signup-total-row">
                              <span>Subtotal</span>
                              <span>£{totalPrice()}</span>
                            </div>
                            <div className="signup-total-row signup-total-row--discount">
                              <span>Coupon ({appliedCoupon.code})</span>
                              <span>-£{appliedCoupon.discountAmount}</span>
                            </div>
                            <h2 className="signup-total-heading">
                              Total: <span className="signup-total-amount">£0</span>{" "}
                              <span className="signup-total-note">due today</span>
                            </h2>
                          </div>
                        )}
                      </div>
                    )}

                    <div className="signup-user-type-block">
                      <p className="signup-form-hint">
                        Already have an account? To add products to it, please contact{" "}
                        <a href={contactMailto}>{contactEmail}</a>.
                      </p>
                    </div>

                    <h4 className="order-summary-section-title">
                      Sign up Details
                    </h4>

                    <div className="user-details-section">
                      <h5 className="signup-form-heading signup-form-heading--tight">Your details</h5>

                      <div className="user-details-name-wrapper">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          required
                        />
                        <input
                          type="text"
                          name="surname"
                          placeholder="Surname"
                          required
                        />
                      </div>


                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Email"
                        required
                      />

                      <p className="signup-form-hint" id="password-requirements">
                        {PASSWORD_REQUIREMENTS_HINT}
                      </p>
                      <input
                        type="password"
                        name="password"
                        id="password"
                        placeholder="Password"
                        autoComplete="new-password"
                        minLength={8}
                        aria-describedby="password-requirements"
                        required
                      />

                      <input
                        type="password"
                        name="confirmPassword"
                        id="confirmPassword"
                        placeholder="Confirm password"
                        required
                      />
                    </div>

                    <div className="signup-terms-row">
                      <input type="checkbox" name="agree_to_terms" id="agree_to_terms" defaultChecked={false} required />
                      <label htmlFor="agree_to_terms">
                        I agree to {brand.displayName}&apos;s{" "}
                        <a href={marketingUrl("/terms-and-conditions")} target="_blank" rel="noopener noreferrer">
                          Terms and Conditions
                        </a>
                        ,{" "}
                        <a href={marketingUrl("/terms-of-use")} target="_blank" rel="noopener noreferrer">
                          Terms of Use
                        </a>
                        , and our{" "}
                        <a href={marketingUrl("/privacy-policy")} target="_blank" rel="noopener noreferrer">
                          Privacy Policy
                        </a>
                        .
                      </label>
                    </div>

                    <div className="signup-terms-row">
                      <input
                        type="checkbox"
                        name="marketing_emails_opt_in"
                        id="marketing_emails_opt_in"
                        defaultChecked
                      />
                      <label htmlFor="marketing_emails_opt_in">
                        I agree to receive emails about future promotions, discounts, product
                        updates and news. We won&apos;t spam you, and you can unsubscribe later.
                        Untick if you want to opt out.
                      </label>
                    </div>

                    {selectedProducts.size > 0 && <CouponSection coupon={coupon} />}

                    <h4 className="order-summary-section-title">
                      Billing Details
                    </h4>

                    <div className="billing-details-section">
                      {stripePromise && (
                        <Elements
                          stripe={stripePromise}
                          options={{
                            mode: "subscription",
                            amount: 10000, // TODO: what is this???!
                            currency: "gbp",
                            payment_method_types: ["card"],
                          }}
                        >
                          <CheckoutForm products={Array.from(selectedProducts)} couponCode={appliedCoupon?.code} />
                        </Elements>
                      )}
                    </div>
                  </form>
                </div>

                <div className="key-features-col">
                  <h3 className="key-features-title">Key Features</h3>

                  <div className="key-features-list-wrapper">
                    <ul>
                      {brand.signupKeyFeatures.map((feature) => (
                        <li key={feature}>
                          <Checkmark />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* <img
                    src={stripePaymentIllustration}
                    className="stripe-payment-illustration"
                    alt=""
                  /> */}
                  <img
                    src={poweredByStripe}
                    alt="Powered by Stripe.com"
                    id="powered-by-stripe"
                  />
                  <p id="please-contact-us">
                    Please contact{" "}
                    <a href={contactMailto}>{contactEmail}</a> for any
                    support
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SignUpPage;
